import { useNavigate } from "react-router";

export const FileComponent = () => {
  const navigate = useNavigate();
  return (
    <button
      className="btn glass flex flex-col lg:flex-row gap-2 items-center justify-center"
      onClick={() => {
        navigate("/report");
      }}
    >
      <span className="badge badge-neutral">New</span>
      <p className="text-white">Votre rapport est prêt</p>
      <img
        alt="rocket"
        src="/image/rocket-svgrepo-com.svg"
        className="animate-bounce w-[32px] lg:w-[42px]"
      />
    </button>
  );
};
